import React from 'react';
import { mediaOverlayInfo } from './fullscreenOverlay.styles';
import type { MediaOverlayInfoProps } from './types';

/**
 * MediaOverlayInfo Component
 *
 * Overlay information displayed at the bottom of media variant.
 * Used for property details, pricing, and call-to-action in immersive view.
 *
 * @example Property details overlay
 * <MediaOverlayInfo>
 *   <h1>Infinity Capitol Hill Apartments</h1>
 *   <p>Apt building in Seattle, WA</p>
 *   <p>$1,860 - $3,200/mo ✓ Total price</p>
 *   <p>Studio - 3 beds | 58 units available</p>
 *   <button>View full property details</button>
 * </MediaOverlayInfo>
 */
export const MediaOverlayInfo = ({ children }: MediaOverlayInfoProps) => {
  return <div className={mediaOverlayInfo}>{children}</div>;
};
